/* ============================================================
   spn-maker-page.js — メーカー一覧 / メーカー別の機種一覧（/pages/maker-list）
   移植元: assets/machines.js renderMakerPage / renderMakerTypeCards / renderMakerDetail /
          renderMakerOverview / renderMachineCardListWithPagination
   変更点: 種類はスマスロ・スマパチのみ（2026-10-13 決定）。種類の絞り込みは ?machine_type=
          （Shopify 標準の ?type= と衝突させない）。リンク先は Shopify の URL。
   前提: spn-machines-data.js → spn-machine-core.js の後に読み込む
   ============================================================ */
(function () {
  "use strict";
  var M = window.SPN_MACHINES;
  var target = document.querySelector("[data-render='maker-page']");
  if (!M || !target) return;
  var esc = M.escapeHtml;
  var PAGE_SIZE = 60;
  var BASE = "/pages/maker-list";
  var MIN_PRICE = window.SPN_UNIT_MIN_PRICE || {};   // { smaslo: 5800, smapachi: 5800 }（Liquid が出力）

  var TYPES = [
    { type: "smaslo", label: "スマスロ", desc: "スマートパチスロ機",
      iconSvg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="12" rx="2"/><path d="M7 10v4M12 10v4M17 10v4"/><circle cx="20" cy="4" r="2" fill="currentColor" opacity="0.7"/></svg>' },
    { type: "smapachi", label: "スマパチ", desc: "スマートパチンコ機",
      iconSvg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.5"/><circle cx="20" cy="4" r="2" fill="currentColor" opacity="0.7"/></svg>' }
  ];
  var findType = function (t) { return TYPES.find(function (x) { return x.type === t; }) || null; };

  var params = new URLSearchParams(location.search);
  var makerSlug = params.get("m") || "";
  var activeType = findType(params.get("machine_type")) ? params.get("machine_type") : "";

  function url(m, t) {
    var q = [];
    if (t) q.push("machine_type=" + encodeURIComponent(t));
    if (m) q.push("m=" + encodeURIComponent(m));
    return BASE + (q.length ? "?" + q.join("&") : "");
  }

  function typeCards(active, forMaker) {
    var stats = { smaslo: 0, smapachi: 0 };
    M.getEnabled().forEach(function (m) { if (!forMaker || m.maker === forMaker) stats[m.machine_type]++; });
    return '<div class="maker-type-cards">' + TYPES.map(function (t) {
      var count = stats[t.type];
      return '<a class="maker-type-card type-' + t.type + (t.type === active ? " is-active" : "") + (count === 0 ? " is-empty" : "") +
        '" href="' + url(forMaker, t.type) + '"><span class="type-icon">' + t.iconSvg + '</span>' +
        '<div class="type-name">' + esc(t.label) + '</div><div class="type-desc">' + esc(t.desc) + '</div>' +
        '<div class="type-count">' + (count > 0 ? count + " 機種" : "準備中") + "</div></a>";
    }).join("") + "</div>";
  }

  // 見本 renderMachineCardHtml（対応商品の最安値つき）
  function cardHtml(m) {
    var price = MIN_PRICE[m.machine_type];
    return '<a class="machine-card" href="' + M.machineUrl(m.slug) + '">' + M.thumbHtml(m, "machine-thumb-card") +
      '<div class="mc-body"><div class="mc-maker">' + esc(M.makerName(m.maker)) + '</div>' +
      '<div class="mc-name">' + esc(m.name) + "</div>" +
      (price ? '<div class="mc-price-from">対応商品 ¥' + Number(price).toLocaleString("ja-JP") + "〜</div>" : "") +
      "</div></a>";
  }

  function listWithLoadMore(list) {
    var html = '<div class="machine-card-list" data-machine-grid>' + list.slice(0, PAGE_SIZE).map(cardHtml).join("") + "</div>";
    if (list.length > PAGE_SIZE) {
      html += '<button type="button" class="btn-load-more" data-load-more><span class="lm-text">もっと見る</span>' +
        '<span class="lm-count">残り <strong>' + (list.length - PAGE_SIZE) + "</strong> 件</span></button>";
    }
    return html;
  }
  function bindLoadMore(list) {
    var shown = PAGE_SIZE;
    var btn = target.querySelector("[data-load-more]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var grid = target.querySelector("[data-machine-grid]");
      grid.insertAdjacentHTML("beforeend", list.slice(shown, shown + PAGE_SIZE).map(cardHtml).join(""));
      shown += PAGE_SIZE;
      if (shown >= list.length) btn.remove();
      else btn.querySelector(".lm-count strong").textContent = list.length - shown;
    });
  }

  function setHeader(breadcrumbHtml, h1, desc) {
    var bc = document.querySelector(".collection-header .breadcrumb");
    var h = document.querySelector(".collection-header h1");
    var d = document.querySelector(".collection-header .desc");
    if (bc) bc.innerHTML = breadcrumbHtml;
    if (h) h.textContent = h1;
    if (d) d.textContent = desc;
  }

  function renderDetail() {
    var maker = M.makerName(makerSlug);
    var all = M.machinesByMaker(makerSlug, null, 5000);
    var list = activeType ? all.filter(function (m) { return m.machine_type === activeType; }) : all;
    var typeWord = activeType ? findType(activeType).label + " " : "";
    setHeader('<a href="/">トップ</a><span class="sep">›</span><a href="' + BASE + '">メーカー</a><span class="sep">›</span><span>' + esc(maker) + "</span>",
      maker + " の" + typeWord + "対応機種",
      maker + " の" + typeWord + "対応機種を " + list.length + " 機種掲載しています。お持ちの機種をお選びください。");
    document.title = maker + " 対応機種 – " + document.title.split(" – ").pop();

    var stats = { smaslo: 0, smapachi: 0 };
    all.forEach(function (m) { stats[m.machine_type]++; });
    var back = url("", activeType);
    var html = '<a class="maker-back-btn" href="' + back + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 5l-7 7 7 7"/></svg><span>メーカーから探す（一覧へ戻る）</span></a>';
    html += typeCards(activeType, makerSlug);
    html += '<div class="maker-banner"><div class="maker-monogram">' + esc((maker || "?").charAt(0)) + '</div><div class="maker-banner-info">' +
      '<div class="maker-banner-label">対応機種一覧</div><h2 class="maker-banner-name">' + esc(maker) + '</h2><div class="maker-banner-meta">' +
      '<span class="mb-total">' + all.length + " 機種</span>" +
      (stats.smaslo ? '<span class="mb-pill mb-smaslo">スマスロ ' + stats.smaslo + "</span>" : "") +
      (stats.smapachi ? '<span class="mb-pill mb-smapachi">スマパチ ' + stats.smapachi + "</span>" : "") +
      "</div></div></div>";
    html += '<div class="section-head" style="margin-bottom: 14px; margin-top: 18px;"><h3 style="font-size: 16px;">' +
      (activeType ? "絞り込み: " + esc(typeWord) : "全機種") + " (" + list.length + ' 件)</h3><a href="' + back + '" class="more">← メーカー一覧へ戻る</a></div>';
    if (!list.length) {
      target.innerHTML = html + '<p style="text-align:center;color:var(--text-mute);padding:40px 0;">該当する機種がありません</p>';
      return;
    }
    target.innerHTML = html + listWithLoadMore(list);
    bindLoadMore(list);
  }

  function renderOverview() {
    var counts = {};
    M.getEnabled().forEach(function (m) {
      counts[m.maker] = counts[m.maker] || { smaslo: 0, smapachi: 0 };
      counts[m.maker][m.machine_type]++;
    });
    var makers = Object.keys(counts).map(function (slug) {
      var c = counts[slug];
      return { slug: slug, name: M.makerName(slug), smaslo: c.smaslo, smapachi: c.smapachi, total: c.smaslo + c.smapachi };
    }).filter(function (mk) { return activeType ? mk[activeType] > 0 : mk.total > 0; });
    var key = function (mk) { return activeType ? mk[activeType] : mk.total; };
    makers.sort(function (a, b) { return key(b) - key(a) || a.name.localeCompare(b.name, "ja"); });

    var heading = activeType ? findType(activeType).label + " 対応メーカー" : "全メーカー";
    var html = '<div class="maker-type-select-prompt">機種タイプを選んでください</div>' + typeCards(activeType, "");
    html += '<div class="section-head" style="margin-bottom: 14px; margin-top: 24px;"><h2>' + esc(heading) + '</h2>' +
      '<span style="font-size: 14.5px; color: var(--text-mute);">' + makers.length + " メーカー</span></div>";
    html += '<div class="maker-grid">' + makers.map(function (mk) {
      var pills = "";
      if (activeType !== "smapachi" && mk.smaslo) pills += '<span class="bd-pill bd-smaslo">スマスロ ' + mk.smaslo + "</span>";
      if (activeType !== "smaslo" && mk.smapachi) pills += '<span class="bd-pill bd-smapachi">スマパチ ' + mk.smapachi + "</span>";
      return '<a class="maker-card" href="' + url(mk.slug, activeType) + '"><div class="name">' + esc(mk.name) + '</div><div class="maker-card-breakdown">' + pills + "</div></a>";
    }).join("") + "</div>";
    target.innerHTML = html;
  }

  if (makerSlug && M.makers[makerSlug]) renderDetail();
  else renderOverview();
  if (window.LINE && typeof window.LINE.rebind === "function") window.LINE.rebind();
})();
